import type { HighlightCardElement } from "@/components/HighlightCard/HighlightCard";
import type { HighlightsGridModuleType } from "@/modules/HighlightsGrid/HighlightsGrid.server";
import { requireDefined } from "@/utils/envs";
import { WPClient } from "@/wp/client/WPClient";
import type { Post } from "@aleksundshantu/gp-types/client";

interface FetchHighlightsProps {
  page: number;
  postsPerPage: number;
  offset: number;
  locale: string | undefined;
  module: HighlightsGridModuleType;
  abortController?: AbortController;
  categoryOverride?: number[];
  excludeIds?: number[];
}

export const fetchHighlights = async ({
  module,
  page,
  postsPerPage,
  offset,
  locale,
  abortController,
  categoryOverride,
  excludeIds,
}: FetchHighlightsProps) => {
  const defaultLocale = requireDefined(process.env.NEXT_PUBLIC_DEFAULT_LOCALE);
  const client = new WPClient({ locale, defaultLocale });

  const { categories, posts: selectedPosts, type } = module.highlights_grid;
  const categoryIds = categoryOverride || categories || [];

  const postsResult = await client.getPosts<
    Post<"highlights">,
    [],
    "highlights"
  >({
    type: "highlights",
    page,
    perPage: postsPerPage,
    offset,
    fields: [],
    ...(type === "posts" && {
      includeIds: { ids: selectedPosts || [], keepOrder: true },
    }),
    ...((type === "categories" || categoryOverride) &&
      categoryIds.length > 0 && {
        customParams: {
          highlights_category: categoryIds.join(","),
        },
      }),
    excludeIds,
    abortController,
  });

  const posts = postsResult.posts.map((post) => {
    const header = post.acf?.header_highlights;
    // const headerLink =
    //   header?.link && typeof header.link !== "string" ? header.link.url : "";

    return {
      title: header?.title || "",
      subline: header?.subline || "",
      excerpt: header?.excerpt || "",
      image: header?.image || false,
      link: post.link,
      date: header?.date || "",
      end_date: header?.end_date || "",
    } as HighlightCardElement;
  });

  return {
    posts,
    totalPosts: postsResult.totalPosts,
  };
};
